//Get absolute distance to the top of the document:
const getDistanceToTop = function (element) {
  let distance = element.offsetHeight;
  while (element) {
    distance += element.offsetTop;
    element = element.offsetParent;
  }
  return distance;
};

const stickyButton = document.querySelector(".product-form__buttons");
if (stickyButton && !stickyButton.closest("quick-add-modal")) {
  //Only run if the button is found
  //and if the button is not in a modal(quick add)
  function handleStickyATC(stickyButton) {
    const buttonParent = stickyButton.parentElement;
    const distanceToTop = getDistanceToTop(buttonParent);
    if (window.pageYOffset > distanceToTop) {
      document
        .querySelector(".product-form__buttons")
        .setAttribute(
          "style",
          "position: fixed; bottom: 50px; width: 80%; left: 0; right: 0; margin: 0 auto; z-index: 999;"
        );
    } else {
      document
        .querySelector(".product-form__buttons")
        .setAttribute("style", "");
    }
  }

  // Initial Call:
  handleStickyATC(stickyButton);
  window.addEventListener("scroll", function () {
    handleStickyATC(stickyButton);
  });
}

if (document.querySelector("body.template--collection")) {
  document.querySelector("cart-drawer").remove();
}

const rightNutModalWrapper = document.querySelector(".rightNutWrapper");
const rightNutContent = document.querySelector(
  ".howToFindTheRightNut .multicolumn-list"
);
const rightNutModalTrigger = document.querySelector(".rightNutTrigger");

if (rightNutModalWrapper && rightNutModalTrigger && rightNutContent) {
  rightNutModalWrapper
    .querySelector(".rightNutModalContent")
    .appendChild(rightNutContent);
  const showrightNutModal = () => {
    rightNutModalWrapper.classList.add("shown");
    document.querySelector("body").style.overflow = "hidden";
  };

  const hiderightNutModal = () => {
    rightNutModalWrapper.classList.remove("shown");
    document.querySelector("body").style.overflow = "";
  };

  rightNutModalWrapper
    .querySelectorAll(".closeRightNutModal,.rightNutOverlay")
    .forEach((el) => {
      el.addEventListener("click", (e) => {
        hiderightNutModal();
      });
    });

  rightNutModalTrigger.addEventListener("click", (e) => {
    e.preventDefault();
    showrightNutModal();
  });
}

document
  .querySelector(".mainProductRatingWrapper")
  ?.addEventListener("click", (e) => {
    const reviewWidget = document.querySelector("[data-oke-widget]");
    if (!reviewWidget) return;
    document
      .querySelector("html")
      .scroll({ left: 0, top: reviewWidget.offsetTop, behavior: "smooth" });
  });